import axios from 'axios';

import { ITEM_HUB_URL_INVENTORY_V1 } from '../constants';
import reject from '../reject';

export function getItemsHub(queryParams) {
  return axios
    .get(ITEM_HUB_URL_INVENTORY_V1, {
      params: { ...queryParams },
      withCredentials: true,
    })
    .catch(reject);
}

export function postItemHub(data) {
  return axios
    .post(ITEM_HUB_URL_INVENTORY_V1, data, {
      withCredentials: true,
    })
    .catch(reject);
}

export function putItemById(id, data) {
  return axios
    .put(`${ITEM_HUB_URL_INVENTORY_V1}/${id}`, data, {
      withCredentials: true,
    })
    .catch(reject);
}

export function getItemById(id, params?) {
  return axios
    .get(`${ITEM_HUB_URL_INVENTORY_V1}/${id}`, {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function deleteItemById(id, params?) {
  return axios
    .delete(`${ITEM_HUB_URL_INVENTORY_V1}/${id}`, {
      params,
      withCredentials: true,
    })
    .catch(reject);
}
